import { Component, Input } from "@angular/core";

@Component({
    selector: "luv-validationError",
    template: `
    <span *ngIf="show" class="field-error-wrapper">{{errorMessage}}<br/><ng-content></ng-content></span>
    `,
    styleUrls: ['validation-error.component.scss']
})
export class ValidationErrorComponent {
    @Input("errorMessage") public errorMessage: string;
    @Input() public show: boolean = true;
}
